<template>
  <v-card flat color="transparent" class="pa-0" style="min-height: 50rem;" :loading="loading">
    <v-row>
      <v-col cols="12" class="d-flex justify-center ma-2">
        <v-text-field
          :label="$t('portfolio.general.searchIn', { title: $t('portfolio.Goals.title') })"
          v-model="search"
          append-icon="mdi-magnify"
          outlined
          dense
          hide-details
        />
      </v-col>
    </v-row>
    <v-row class="ma-0 pa-0">
      <v-col v-for="(statusName, statusKey) in statusMap" :key="statusKey" class="kanban-column">
        <v-card class="mb-4">
          <drop
            :key="statusKey + '-drop'"
            class="drop"
            s
            @drop="val => onDrop(val, statusKey)"
            :accepts-data="function(val) {
                return acceptsDataCheck(val, statusKey);
              }
            "
          >
            <v-toolbar flat :color="statusName.color" dark dense rounded>
              <v-icon small class="me-3">{{ statusName.icon }}</v-icon>
              <v-toolbar-title class="text-subtitle-1">{{ statusName.name }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                v-if="studentGuid === $store.state.userData.guid"
                icon
                @click="$refs.addGoalsDialog.showDialog(parseInt(statusKey))"
                :title="$t('portfolio.Goals.add')"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>
            <v-card-text class="pa-1">
              <drop-list
                :items="filteredItems(parseInt(statusKey))"
                class="list pa-1"
                style="max-height: 45rem; overflow-y: auto;"

              >
                <template v-slot:item="{ item, index }">
                  <drag  :disabled="studentGuid !== $store.state.userData.guid"
                    outlined
                    :key="item.goalGuid"
                    class="drag"
                    @dragstart="pickupItem(item)"
                    @dragend="dragItemEnd(statusKey)"
                  >
                    <v-card
                      outlined
                      :title="item.visible ? '' : $t('portfolio.Goals.hidden')"
                      :class="
                        item.visible
                          ? 'mb-2'
                          : $vuetify.theme.dark
                          ? 'category-unactive-dark mb-2'
                          : 'category-unactive-light mb-2'
                      "
                    >
                      <div class="d-flex justify-between pa-1">
                        <v-menu
                          dense
                          v-if="studentGuid === $store.state.userData.guid"
                          offset-y
                          transition="scale-transition"
                          :close-on-content-click="false"
                          :nudge-top="10"
                          :nudge-right="10"
                          :nudge-bottom="10"
                          :nudge-left="10"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" :title="$t('options')" small>
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item @click="$refs.addGoalsDialog.showEditDialog(item)">
                              <v-list-item-icon class="me-2"
                                ><v-icon>mdi-pencil</v-icon></v-list-item-icon
                              >
                              <v-list-item-title>
                                {{ $t("portfolio.Goals.edit") }}
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="deleteGoal(item)">
                              <v-list-item-icon class="me-2"
                                ><v-icon color="red">mdi-delete</v-icon></v-list-item-icon
                              >
                              <v-list-item-title>
                                {{ $t("portfolio.Goals.confirmDelete") }}
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-card-title :title="item.title"
                          dir="auto"
                          class="text-subtitle-1 text-justify text-warp two-lines-text pa-0"
                        >
                          {{ item.title }}
                        </v-card-title>
                      </div>

                      <v-card-subtitle
                        class="pa-1 px-2"
                        :style="{
                          color:
                            parseInt(item.progressStatus) !== 2 &&
                            new Date(item.dueDate) < new Date()
                              ? 'red'
                              : ''
                        }"
                      >
                        {{ $t("portfolio.Goals.dueDate") }}:
                        {{ item.dueDate | moment("YYYY/MM/DD") }}
                      </v-card-subtitle>
                      <v-card-subtitle class=" two-lines-text pa-1 px-2" :title="item.description">
                        {{ item.description }}
                      </v-card-subtitle>
                      <div class=" d-flex  align-center">
                        <TagsMini class="ma-2"
                          v-model="item.tags"
                          :sourceGuid="item.goalGuid"
                          sourceType="Goals"
                          :showAdd="isInRole(0)"
                          :isRemovable="isInRole(0)"
                        />
                      </div>
                      <v-card-subtitle
                        class="pa-1 px-2"
                        :title="item.createdDate | moment('YYYY/MM/DD - h:mm A')"
                      >
                        <span class="text-caption"> {{ dateFromNow(item.createdDate) }}</span>
                      </v-card-subtitle>
                      <v-card-actions class="mt-1">
                        <v-btn
                          text
                          small
                          color="primary"
                          @click="navToDetails(item)"
                        >
                          <v-icon small>mdi-file-find</v-icon>
                          {{ $t("preview") }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </drag>
                </template>
              </drop-list>
              <div
                class="text-center"
                v-if="filteredItems(parseInt(statusKey)).length === 0"
              >
                {{ $t("noItems") }}
              </div>
            </v-card-text>
          </drop>
        </v-card>
      </v-col>
    </v-row>

    <GoalsDialog ref="addGoalsDialog" @success="getGoals" />
    <ConfirmActionDialog
      :title="$t('portfolio.Goals.confirmDelete')"
      :description="$t('portfolio.Goals.confirmDeleteMessage', { title: activeGoal.title })"
      ref="confirmationDialog"
      @confirm="deleteGoalConfirmed"
    />
  </v-card>
</template>

<script>
import NoData from "@/components/noData.vue";
import ConfirmActionDialog from "@/components/confirmActionDialog.vue";
import BaseCard from "../../../components/portfolio/baseCard.vue";
import SearchTextField from "../../../components/portfolio/searchTextfield.vue";
import GoalsDialog from "../../../components/portfolio/goals/goalsDialog.vue";
import LoadingData from "../../../components/loadingData.vue";
import { Drag, Drop, DropList } from "vue-easy-dnd"; // Adjust the path to your components
import TagsMini from "@/components/portfolio/tagsMini.vue";

export default {
  name: "Goals",
  props: {
    studentGuid: {
      required: true,
      type: String
    }
  },
  components: {
    BaseCard,
    SearchTextField,
    GoalsDialog,
    ConfirmActionDialog,
    NoData,
    LoadingData,
    Drag,
    Drop,
    DropList,
    TagsMini
  },
  data() {
    return {
      activeGoal: {
        title: ""
      },
      loading: true,
      goals: [],
      search: null, // Added for search
      currentPage: 1,
      itemsPerPage: 4,
      draggedItem: null, // For drag and drop functionality
      selectedItemIndex: null, // To track the index of the selected item
      allowDrag: true
    };
  },

  mounted() {
    this.getGoals();
  },
  methods: {
    filteredItems(status) {
      return this.filteredGoals
        .filter(i => i.progressStatus === parseInt(status))
        .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
    },

    pickupItem(item) {
      this.draggedItem = item;
    },
    dragItemEnd(e) {
      this.draggedItem = null;
    },
    onDrop(val, statusKey) {
      if (!this.draggedItem) {
        return;
      }
      this.changeProgressStatus(this.draggedItem, parseInt(statusKey));
    },
    acceptsDataCheck(val, statusKey) {
      return this.draggedItem && this.draggedItem.progressStatus !== parseInt(statusKey);
    },

    navToDetails(goal) {
      this.$router.push({ name: "portfolio.Goals.details", params: { id: goal.goalGuid } });
    },
    getGoals() {
      this.loading = true;
      if (this.isInRole(2)) {
        this.axios
          .get("/Goal/Get", { params: { studentGuid: this.studentGuid } })
          .then(response => {
            this.goals = response.data.data;
          })
          .catch(error => {
            console.error("Error fetching goals:", error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (this.isInRole(0)) {
        this.axios
          .get("/Goal/Get", null, { params: { studentGuid: this.studentGuid } })
          .then(response => {
            this.goals = response.data.data;
          })
          .catch(error => {
            console.error("Error fetching goals:", error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    changeProgressStatus(goal, status) {
      this.loading = true;
      var prevousStatus = goal.progressStatus;
      goal.progressStatus = status;

      this.axios
        .post(`/Goal/ChangeProgressStatus/${goal.goalGuid}/${status}`, goal)
        .then(() => {
          this.getGoals();
        })
        .catch(error => {
          goal.progressStatus = prevousStatus;
          console.error("Error changing progress status:", error);
          this.$swal.fire({
            title: this.$t("AnErrorOccurredDuringTheProcess"),
            text: "",
            icon: "error",
            confirmButtonText: this.$t("close")
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteGoal(goal) {
      this.activeGoal = goal;
      this.$refs.confirmationDialog.showDialog();
    },
    deleteGoalConfirmed() {
      this.axios
        .post("/Goal/Delete", { goalGuid: this.activeGoal.goalGuid })
        .then(() => {
          this.getGoals();
        })
        .catch(error => {
          console.error("Error deleting goal:", error);
        });
    },

    getStatusColor(status) {
      const statusColors = ["red", "blue", "green", "grey"];
      return statusColors[status] || "grey";
    }
  },

  computed: {
    statusMap() {
      const statusNames = {
        0: {
          name: this.$t("portfolio.Goals.ProgressStatus.toDo"),
          color: "blue",
          icon: "mdi-checkbox-blank-circle-outline"
        },
        1: {
          name: this.$t("portfolio.Goals.ProgressStatus.inProgress"),
          color: "orange",
          icon: "mdi-progress-clock"
        },
        2: {
          name: this.$t("portfolio.Goals.ProgressStatus.achieved"),
          color: "green",
          icon: "mdi-check-circle-outline"
        },
        3: {
          name: this.$t("portfolio.Goals.ProgressStatus.later"),
          color: "grey",
          icon: "mdi-clock-outline"
        },
        4: {
          name: this.$t("portfolio.Goals.ProgressStatus.cancelled"),
          color: "red",
          icon: "mdi-close-circle-outline"
        }
      };
      return statusNames;
    },

    filteredGoals() {
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        return this.goals.filter(
          goal =>
            (goal.title && goal.title.toLowerCase().includes(searchLower)) ||
            (goal.description && goal.description.toLowerCase().includes(searchLower))
        );
      }
      return this.goals;
    }
  }
};
</script>

<style scoped>
.goals {
  padding: 1.25rem;
}

.samples-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
}

.wrapped-text {
  word-break: normal;
  overflow-wrap: normal;
  white-space: normal;
}
.two-lines-text {
  max-height: 53px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: auto-phrase;
}
</style>
<style scoped>
.kanban-column {
  min-width: 250px;
}
</style>
<style>
.category-unactive-dark {
  background: rgba(255, 191, 0, 0.03);
  background-image: repeating-linear-gradient(
    -45deg,
    #272727,
    #242432 10px,
    #00000045 0,
    #242432 20px
  );
}
.category-unactive-light {
  background: rgba(255, 191, 0, 0.03);
  background-image: repeating-linear-gradient(
    -45deg,
    rgb(238 238 238),
    rgba(0, 0, 0, 0.02) 10px,
    transparent 0,
    transparent 20px
  );
}
</style>
